import rightImg from "images/sectionhero.png";
import rightImg1 from "images/setupapart.png";
import React, { FC } from "react";
import SectionFounder from "./SectionFounder";
import SectionStatistic from "./SectionStatistic";
import { Helmet } from "react-helmet";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionHero from "./SectionHero";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import { globalJson } from "global/global_json";
import SectionHero2 from "./SectionHero2";
import AboutUsSection from "./AboutUsSection";
import SectionInfoBanner from "./SectionInfoBanner";
import WhyChooseUs from "components/WhyChooseUS/WhyChooseUs";
import WhatSetsUsApart from "components/SetupApart/SetupApart";

export interface PageAboutProps {
  className?: string;
}

const PageAbout: FC<PageAboutProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-PageAbout overflow-hidden relative ${className}`}
      data-nc-id="PageAbout"
    >
      <Helmet>
        <title>About || Car rental</title>
      </Helmet>

      <div className="container py-16 lg:py-28 space-y-16 ">
        <SectionHero2
          rightImg={rightImg}
          heading="About Us"
          btnText=""
          subHeading={` We pride ourselves on providing a luxury car and motorsports rental
            experience that is as seamless as it is customized. Each vehicle is
            crafted to give the impression of personal ownership, devoid of any
            branding or indicators of a rental, meanwhile our motorsports
            vehicles are not just visually appealing, but top-class in
            innovation and technology.
            Every car and motorcraft is delivered in immaculate
            condition, having been thoroughly cleaned and professionally
            detailed, with attention to the smallest leather detail. If you are
            interested in our auto media and advertising for your luxury
            vehicle, give us a call!`}
        />
      </div>
      <div className="container py-16 lg:py-28 space-y-16 ">
        <div className="bg-[#B4B4B41A] rounded-2xl">
          <div className="relative py-16">
            <SectionClientSay uniqueClassName="PageAbout_" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageAbout;
